<template>
  <div v-if="currentUser.type=='Admin' || currentUser.type=='Seller'" class="min-h-screen api flex-1 mt-1 bg-gray-100 px-4 py-3 items-center">
    <div class="bg-white w-full rounded-lg shadow p-10" id="genarateToken" style="height: 99%;border: 1px solid white;page-break-after: avoid; page-break-before: avoid;">
      <div class="flex justify-between"><h2 id="h_linking_in_api_documentation">Documentation API:</h2><div class="relative mr-4 inline-block"><div class="text-gray-500 cursor-pointer w-10 h-10 rounded-full bg-gray-100 hover:bg-gray-300 inline-flex items-center justify-center"><svg @click="generatePdf" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round" class="icon icon-tabler icon-tabler-printer"><rect x="0" y="0" width="24" height="24" stroke="none"></rect><path d="M17 17h2a2 2 0 0 0 2 -2v-4a2 2 0 0 0 -2 -2h-14a2 2 0 0 0 -2 2v4a2 2 0 0 0 2 2h2"></path><path d="M17 9v-4a2 2 0 0 0 -2 -2h-6a2 2 0 0 0 -2 2v4"></path><rect x="7" y="13" width="10" height="8" rx="2"></rect></svg></div><div x-show.transition="showTooltip" class="z-40 shadow-lg text-center w-32 block absolute right-0 top-0 p-2 mt-12 rounded-lg bg-gray-800 text-white text-xs" style="display: none;"> Print this invoice! </div></div></div>
       
       <div class="p-5">
          <hr class="divide_hr">
          <h2 id="link_same_file_default">Token Généreration </h2>
    
          <section>   
            <div class="border border-gray-700 border-dashed p-4">
                      <p class="marker"><span class="circle-range"></span><strong>Get authorisation token:</strong></p>
                      <pre>https://api.shipsen.com/users/apilogin</pre>
                      <p class="marker"><span class="circle-range"></span><strong>Body params:</strong></p>
                      <pre class="NoteP">
                              {
                              <span class="objet"> 
                                key: "<span class="text-red-500">.........................................</span>",<br>
                                secret: "<span class="text-red-500">.........................................</span>"
                              </span>
                            }
                      </pre>
                      <p class="marker"><span class="circle-range"></span><strong>Response Sample:</strong><span class="block">HTTP/1.1 200</span></p>
                      <pre class="NoteP">
                        {
                          <span class="objet">  token : "<span class="text-red-500">xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx</span>" </span>
                        }
                      </pre>
                      <p class="Note"><strong>Note</strong>: Token expire every 5 minutes</p>
                      <!-- <pre>{{formData.token}}</pre> -->
                    </div>   
                    <div class="border border-gray-700 border-dashed p-4 mt-2">
                      <p class="marker"><span class="circle-range"></span><strong>Header params:</strong></p>
                        <pre><strong>Content-Type </strong>: application/json;charset=utf-8<br>
                          <strong>x-auth-token </strong>: {token}
                        </pre>
                    </div>
          
           <div class="border border-gray-700 border-dashed p-4 mt-2">
            <p class="marker"><span class="circle-range"></span><strong>Base order URL creation:</strong></p>
            <pre>https://api.shipsen.com/orders/apicreate</pre>
         
            
              <p class="marker"><span class="circle-range"></span><strong>Post DATA:</strong></p>
             <pre class="NoteP">
                      {
                      <span class="objet"> 
                      orderId:{ type: String, required: true, maxlength: 250 }, <span class="comment">//order id</span><br>
                      source:{ type: String, required: true, maxlength: 300 }, <span class="comment">//source de trafic</span><br>
                      fullName: { type: String, required: true, maxlength: 250 },<span class="comment">//customer name (*)</span><br>
                      phone: { type: String, required: true, maxlength: 100 },<span class="comment">(*)</span><br>
                      country: { type: String, required: true, maxlength: 2 }, <span class="comment">//country code</span><br>
                      city: { type: String, maxlength: 50 },<br> 
                      address: { type: String, required: true, maxlength: 250 },<br> 
                      items:[ <span class="comment">//products array info in order in JSON</span> <br>
                      <span class="objet-pr"> {</span>
                      <ul><br>
                        <li> name: { type: String, required: true, maxlength: 250 },<span class="comment">//Nom de produit (*)</span></li>
                        <li> code: { type: String, required: true, maxlength: 100 },<span class="comment">//Code de produit (*)</span> </li>
                        <li> quantity: { type: Number, required: true },<span class="comment">(*)</span> </li>
                        <li> price: { type: Number, required: true }<span class="comment">//Unit price (*)</span></li>
                      </ul><br>
                      <span class="objet-pr"> }</span>
                      ],<br>
                      total: { type: Number, required: true }<span class="comment">//Total amount (*)</span><br>
                      </span>
                    }
              </pre>
              <p class="marker"><span class="circle-range"></span><strong>Response Sample:</strong></p>
              <pre class="NoteP">
                {
                  <span class="objet">  id_order : 65855cc1f55c83e0f2bb8561 </span>
                }
              </pre>
            </div>
           
         

          <div class="border border-gray-700 border-dashed p-4 mt-2">
            <p class="marker"><span class="circle-range"></span><strong>Base order URL update:</strong></p>
            <pre>https://api.shipsen.com/orders/apiupdate?id={id_order}</pre>
         
            
              <p class="marker"><span class="circle-range"></span><strong>Post DATA:</strong></p>
              <pre class="NoteP">
                      {
                      <span class="objet"> 
                        items:[ <span class="comment">//products array info in order in JSON</span> <br>
                        <span class="objet-pr"> {</span>
                      <ul><br>
                        <li> name: { type: String, required: true, maxlength: 250 },<span class="comment">//Nom de produit (*)</span></li>
                        <li> code: { type: String, required: true, maxlength: 100 },<span class="comment">//Code de produit (*)</span> </li>
                        <li> quantity: { type: Number, required: true },<span class="comment">(*)</span> </li>
                        <li> price: { type: Number, required: true }<span class="comment">//Unit price (*)</span></li>
                      </ul><br>
                      <span class="objet-pr"> }</span>
                      ],<br>
                      total: { type: Number, required: true }<span class="comment">//Total amount (*)</span><br>
                      </span>
                    }
              </pre>
              <p class="marker"><span class="circle-range"></span><strong>Response Sample:</strong></p>
              <pre class="NoteP">
                {
                  <span class="objet">  id_order : 65855cc1f55c83e0f2bb8561 </span>
                }
              </pre>
           </div>   

           <div class="border border-gray-700 border-dashed p-4 mt-2">
            <p class="marker"><span class="circle-range"></span><strong>Webhook order creation:</strong></p>
            <pre>https://api.shipsen.com/orders/apicreate?key={KEY_CODE}&secret={SECRET_CODE}&source={SOURCE_NAME}</pre>
           </div>   

           <div class="border border-gray-700 border-dashed p-4 mt-2">
            <p class="marker"><span class="circle-range"></span><strong>Integration Shopify with Webhook</strong></p>
            <h1>Procedure:</h1>
           <ol class="steps bx--list--ordered--temporary list--ordered--indented">
            <li class="step stepexpand bx--list__item">
                <span class="cmd">Navigate to <span class="ph menucascade"><span class="ph uicontrol">Settings</span><abbr title="and then"> &gt; </abbr><span class="ph uicontrol">Notification</span></span>. (In your account in shopify)</span>
            </li>
            <li class="step stepexpand bx--list__item"><span class="cmd">Click <span class="ph uicontrol">Create webhook</span>.</span></li>
            <li class="step stepexpand bx--list__item"><span class="cmd">Specify the Event. <span class="ph uicontrol">(Choose Order Creation)</span>.</span></li>
            <li class="step stepexpand bx--list__item">
              <span class="cmd">Provide a URL webhook.</span> 
              <div class="itemgroup info">Copy and paste this link <span class="ph uicontrol">(https://api.shipsen.com/orders/apicreate?key={KEY_CODE}&secret={SECRET_CODE}&source=SHOPIFY)</span></div>
              <div class="itemgroup info">Don't forget to replace <span class="ph uicontrol">{KEY_CODE}</span> and <span class="ph uicontrol">{SECRET_CODE}</span> with their values, you will find them in your account settings</div>
            </li>
            <li class="step stepexpand bx--list__item"><span class="cmd">Specify Webhook API version. <span class="ph uicontrol">(Choose the last one)</span>.</span></li>
            <li class="step stepexpand bx--list__item"><span class="cmd">Click <span class="ph uicontrol">Save</span>.</span></li>
           </ol>
           <div class="note border-2 bx--inline-notification--info ibmdocs-note bx--inline-notification bx--inline-notification--low-contrast margin-top-1 margin-bottom-1">
            <div class="bx--inline-notification__details"><svg focusable="false" preserveAspectRatio="xMidYMid meet" style="will-change: transform;" xmlns="http://www.w3.org/2000/svg" class="bx--inline-notification__icon" width="20" height="20" viewBox="0 0 32 32" aria-hidden="true"><path d="M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm0,5a1.5,1.5,0,1,1-1.5,1.5A1.5,1.5,0,0,1,16,7Zm4,17.12H12V21.88h2.88V15.12H13V12.88h4.13v9H20Z"></path></svg>
              <div class="bx--inline-notification__text-wrapper">
                <div class="bx--inline-notification__subtitle"><span class="notetitle ibm-bold ibm-textcolor-blue-50 background-blue bx--inline-notification__title ibm-padding-top-1 ibm-padding-bottom-1 padding-left-1 padding-right-1">Note:</span>
                     Don't forget the synchronisation the products between shopify and shipsen <br>
                     The product ID shopify you will find in the link to update the product page (exepmle: https://admin.shopify.com/store/storeino/products/68527971688925) <br>
                     In this case our Shopify product ID is 68527971688925 <br>
                     Now we enter this product ID into our product in <b>Shipsen</b> exactly in a field called <b>code</b> and we save the changes
                  </div>
              </div>
           </div></div>
           <p  class="Note" style="margin-bottom: 0 !important;"><strong>Note</strong>: Si vous utilisez le même produit dans plusieurs pays, vous pouvez ajouter <b>country code</b> dans la section <b>Vendeur</b> dans la partie <b>edit produit</b> (exemple: CI) (Dans votre compte Shopify)</p>
           </div>   

           <div class="border border-gray-700 border-dashed p-4 mt-2">
            <p class="marker"><span class="circle-range"></span><strong>Integration Google Sheet</strong></p>
              <button :disabled="currentUser.type !== 'Seller'?true:false" @click="$vm2.open('ModalSettings')" class="bg-gray-300 hover:bg-gray-400 text-gray-800 font-bold py-2 px-4 rounded inline-flex items-center">
                <span>Generate code d'integration</span>
              </button>
           </div>   

           <p class="Note"><strong>Note</strong>: Country ça sera le country code (par exemple Maroc: MA ,Côte d'Ivoire : CI ...)</p>
          <p class="Note"><strong>Note</strong>: Le nom du produit doit être le même que le nom crée en Plateform Shipsen  </p>
         </section>    
       </div>
    </div>
     <!--Modal callcenter setting -->
     <vue-modal-2 v-if="currentUser.type === 'Seller'" name="ModalSettings" :headerOptions="{title: 'Generate code d\'integration'}" :noFooter="true" modalSize="xl" @onclose="$vm2.close('ModalSettings')">
        <div class="bg-white rounded-lg">
            <div class="bg-white px-4 pt-0 pb-1 mb-20">

              <!-- <div class="">
                <div class="drop-zone" 
                @drop="onDrop($event, 1)"
                @dragover.prevent
                @dragenter.prevent
              >
                <div 
                  v-for="item in listOne" 
                  :key="item.id" 
                  draggable="true"
                  @dragstart="startDrag($event, item)"
                  class="drag-el">

                  {{ item.title }}
                </div>

              </div>

              <div class="drop-zone" 
                @drop="onDrop($event, 2)"
                @dragover.prevent
                @dragenter.prevent
              >
                <div 
                  v-for="item in listTwo" 
                  :key="item.id"
                  draggable="true"
                  @dragstart="startDrag($event, item)"
                  class="drag-el">

                  {{ item.title }}
                </div>
              </div>
              </div> -->
             
              <div class="Note tab-section">
                
                  <p class="Note"><strong>Note</strong>: Votre fichier Excel doit respecter le même format que dans cette exemple ci-dessous (<b>9 columns</b>)</p>
                  <p class="Note"><strong>Note</strong>: Les champs qui sont obligatoire sont marqué avec un cadre</p>
                  <p class="Note"><strong>COUNTRY CODE</strong>: C'est le code de country tu trouve dans la section settings</p>
                  <p class="Note"><strong>COUNTRY NAME</strong>: Specifie le meme country name que vous avez dans votre store (tu peu ajouter les country de chaque warehouse dans la section Prefix order dans la partie settings)</p>
                  <table class="zigzag">
                  <thead>
                    <tr>
                      <th class="header">ORDER ID</th>
                      <th class="header">PRODUCT ID</th>
                      <th class="header">CONSTUMER NAME</th>
                      <th class="header">PHONE</th>
                      <th class="header">CITY/ADRESSE</th>
                      <th class="header">Total</th>
                      <th class="header">QUANTITY</th>
                      <th class="header">STORE NAME</th>
                      <th class="header">COUNTRY CODE/ COUNTRY NAME</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>XX_001</td>
                      <td class="imp">kv6qyr4w</td>
                      <td class="imp">Hassan Shipsen</td>
                      <td class="imp">06 xx xx xx xx</td>
                      <td>CITY</td>
                      <td class="imp">21600</td>
                      <td class="imp">1</td>
                      <td>Storeino</td>
                      <td class="imp">CI</td>
                    </tr>
                    <tr>
                      <td>XX_002</td>
                      <td class="imp">kt6qyr4w</td>
                      <td class="imp">Hassan Shipsen</td>
                      <td class="imp">07 xx xx xx xx</td>
                      <td> ADRESSE</td>
                      <td class="imp">14000</td>
                      <td class="imp">2</td>
                      <td>STORE X</td>
                      <td class="imp">Côte d'Ivoire</td>
                    </tr>
                  </tbody>
                  </table>
               </div>

               <div class="tab-section mt-2">
                  <div class="title-xx">
                    <h3>Install Base Code</h3>
                    <p>
                      The code is a javascript snippet added to the Apps Script section of your Google Sheets.
                    </p>
                  </div>

                  <div class="section-1">
                    <div class="number"><span><strong>1</strong></span></div>
                    <div class="title">Copy base code</div>
                    <div class="sous-title">Copy the base code below.</div>
                    <div class="section-code">
                      <pre class="section-pre" id="codexcel">
                        &#47;&#42; Javascript Api Create Order shipsen Code &#42;&#47;
                        &#47;&#42; Get data &#42;&#47;
                          function lastRowData(){
                                var ss = SpreadsheetApp.getActive()
                                var sheet = ss.getActiveSheet()
                                var lastRow = sheet.getLastRow() 
                                var lastCol = sheet.getLastColumn()
                                var lastRowData = sheet.getRange(lastRow,1,1,lastCol).getValues()
                                return lastRowData[0]
                          }

                          &#47;&#42; Order creation API &#42;&#47;
                          function sendOrder(e) {
                                        
                            if(e.changeType=="INSERT_ROW" || e.changeType=="EDIT"){

                                        var lastRow = lastRowData()
                                        var data = {
                                            'orderId':     lastRow[0],  &#47;&#42; Order id  &#42;&#47;
                                            'fullName' :    lastRow[2], &#47;&#42; customer Name  &#42;&#47;
                                            'phone' :     lastRow[3], &#47;&#42; customer phone  &#42;&#47;
                                            'country' :         lastRow[8], &#47;&#42; country code  &#42;&#47;
                                            'city' :         lastRow[4],
                                            'address' :         lastRow[4],
                                            'total' :         lastRow[5], &#47;&#42; Total price order  &#42;&#47;
                                            'storeName':     lastRow[7],  &#47;&#42; Store Name  &#42;&#47;
                                            'items' : [{
                                                          'name':  lastRow[1], &#47;&#42; Name product  &#42;&#47;
                                                          'code':  lastRow[1], &#47;&#42; id or code product   &#42;&#47;
                                                          'quantity':  lastRow[6],
                                                          'price':  lastRow[5] &#47;&#42; Unit price product  &#42;&#47;
                                                      }]
                                        }


                                      var options = {
                                          'method': 'post',
                                          'contentType': 'application/json',
                                          'payload': JSON.stringify(data),
                                          'timeout' : '0',       
                                          'muteHttpExceptions' : true,
                                      };

                                    var response =  UrlFetchApp.fetch("https://api.shipsen.com/orders/apicreate?key={{currentUser.api.key}}&secret={{currentUser.api.secret}}&source=SHEET", options);

                                } 
                          }
                          &#47;&#42; End Api Create Order shipsen Code &#42;&#47;
                      </pre>
                      <div class="section-bottom"></div>
                    </div>
                     <button class="btn" @click="copyIt('codexcel')">Copy Code</button>
                  </div>

                  <div class="section-1 mt-5">
                    <div class="number"><span><strong>2</strong></span></div>
                    <div class="title">Paste the code into Code.gs</div>
                    <div class="sous-title">Select <b>Extensions</b> > <b>Apps Script</b> > <b>Code.gs</b> from within Google Sheets.<br> Press button <b>Save the project</b>.</div>
                  </div>

                  <div class="section-1 mt-5">
                    <div class="number"><span><strong>3</strong></span></div>
                    <div class="title">Navigate to <b>Trigger</b></div>
                    <ol class="steps bx--list--ordered--temporary list--ordered--indented">
                        <li class="step stepexpand bx--list__item"><span class="cmd">Click button <span class="ph uicontrol">Create Trigger</span>.</span></li>
                        <li class="step stepexpand bx--list__item"><span class="cmd">Choose the function to perform. <span class="ph uicontrol">(Choose sendOrder)</span>.</span></li>
                         <li class="step stepexpand bx--list__item"><span class="cmd">Select the event source. <span class="ph uicontrol">(Choose Spreadsheet-based)</span>.</span></li>
                          <li class="step stepexpand bx--list__item"><span class="cmd">Select an event type. <span class="ph uicontrol">(Choose During a change)</span>.</span></li>
                          <li class="step stepexpand bx--list__item"><span class="cmd">Failure notification settings. <span class="ph uicontrol">(Choose Receive a notification every day)</span>.</span></li>
                          <li class="step stepexpand bx--list__item"><span class="cmd">Click <span class="ph uicontrol">Save</span>.</span></li>
                    </ol>
                  </div>
                  
               </div>
               
            </div>    

            <div class="modal-footer px-5 border0-t text-right">
                 <a href="#" @click="$vm2.close('ModalSettings')" class="flex text-white mx-auto max-w-sm rounded text-center bg-gray-500 py-2 px-8 items-center focus:outline-none md:float-right">Close</a>
            </div>
            <div id="body-bottom"></div>
        </div>
    </vue-modal-2>     
  </div>
</template>




<script>
export default {
  props: {
     currentUser: { type: Object},
     idWharhouse: { type: Object}
   },
  data() {
    return {
      formData: {
        token: null,
        seller:null,
      },
     // currentUser:{},
      sellers:[],
      showSelect:true,
      items: [
        {
          id: 0,
          title: 'Item A',
          list: 1,
        },
        {
          id: 1,
          title: 'Item B',
          list: 1,
        },
        {
          id: 2,
          title: 'Item C',
          list: 2,
        },
      ],
    };
  },
  computed: {
      warhouseSelected(){
        return this.$store.getters["wharhouse/warhouseSelected"]({user:_.pick(this.currentUser,['countries'])})
      },
      listOne() {
         return this.items.filter((item) => item.list === 1)
      },
      listTwo() {
        return this.items.filter((item) => item.list === 2)
      },
   },
   watch: {
      'warhouseSelected': async function(oldVal, newVal) {
         //  await this.getSellers();
      }
  },
  async mounted() {
     //await this.getUser();
    // await this.getSellers();
  },
  methods: {
    copyIt: function(id) {
        console.log('id-----',id)  
        const copyText = document.getElementById(id).textContent;
        const textArea = document.createElement('textarea');
        textArea.textContent = copyText;
        document.getElementById('body-bottom').append(textArea);
        textArea.select();
        document.execCommand("copy");
        document.getElementById("body-bottom").innerHTML = "";
    },
    startDrag(evt, item) {
      evt.dataTransfer.dropEffect = 'move'
      evt.dataTransfer.effectAllowed = 'move'
      evt.dataTransfer.setData('itemID', item.id)
    },
    onDrop(evt, list) {
      const itemID = evt.dataTransfer.getData('itemID')
      const item = this.items.find((item) => item.id == itemID)
      item.list = list
    },
    generatePdf(){
          var printContents = document.getElementById("genarateToken").innerHTML;
          var mywindow = window.open('', 'PRINT', 'height=400,width=600');
          mywindow.document.write('<html lang="en"><head><meta charset="utf-8"><title>Genarate Token</title>');
          mywindow.document.write('<style type="text/css">.bx--inline-notification { max-width: 100% !important; border-left: 3px solid #0043ce; background: #edf5ff;  line-height: 1.625rem; color: #161616; -ms-flex-wrap: nowrap; flex-wrap: nowrap; } .bx--inline-notification { position: relative; display: -webkit-box; display: -ms-flexbox; display: flex; width: 100%; min-width: 18rem; height: auto; min-height: 3rem; } .bx--inline-notification--low-contrast::before { position: absolute; top: 0; left: 0; width: 100%; height: 100%; -webkit-box-sizing: border-box; box-sizing: border-box; border-width: 1px 1px 1px 0; border-style: solid; content: ""; -webkit-filter: opacity(0.4); filter: opacity(0.4); pointer-events: none; border-color: #0043ce; } .bx--inline-notification__details { display: -webkit-box; display: -ms-flexbox; display: flex; -webkit-box-flex: 1; -ms-flex-positive: 1; flex-grow: 1; margin: 0 1rem; line-height: 1.625rem; overflow-x: auto !important; overflow-y: hidden !important; } .bx--inline-notification__icon { -ms-flex-negative: 0; flex-shrink: 0; margin-top: .875rem; margin-right: 1rem; fill: #0043ce; } .bx--inline-notification__text-wrapper { display: -webkit-box; display: -ms-flexbox; display: flex; -ms-flex-wrap: wrap; flex-wrap: wrap; padding: .9375rem 0; line-height: 1.625rem; } .bx--inline-notification__subtitle { font-size: 1rem; font-weight: 400; line-height: 1.5; letter-spacing: 0; word-break: break-word; } .bx--inline-notification__title { display: inline !important; font-size: 1rem; font-weight: 400; line-height: 1.5; letter-spacing: 0; font-weight: bold; margin: 0 .25rem 0 0; padding-bottom: 1rem; padding-top: 1rem; } .bx--list--ordered--temporary { font-size: 1rem !important; font-weight: 400 !important; letter-spacing: 0 !important; list-style-type: decimal !important; line-height: 1.5rem !important; margin-left: 1.75rem !important; margin-bottom: 1.5rem !important; list-style: none; } .bx--list--ordered--temporary > .bx--list__item { padding-left: .25rem !important; } .bx--list__item { color: #161616; margin-top: .25rem; } .uicontrol{ font-weight: bold; }.block {display: block}.objet-pr{padding-left: 10px;display: block;}.mt-2{margin-top: 0.5rem;}.border-gray-700{border-color: #4a5568;}.border-dashed{border-style: dashed;}.border{border-width: 1px;}.p-4 {padding: 1rem;}.circle-range { width: 8px; height: 8px; background: black; border: 5px solid; border-radius: 50%; margin-right: 9px; display: inline-block; vertical-align: middle; }.objet{ display: block; padding-left: 30px; }.no-show{display:none}html {font-family: system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";line-height: 1.5;}.p-5{}.inline-block { display: inline-block;}.relative{position: relative;}mr-4{margin-right: 1rem;}.p-10 {padding: 2.5rem}.w-full {width: 100%;}.flex {display: flex;}.justify-between {justify-content: space-between;}.NoteP .comment{ color: #13a171; } .api h2 { font-size: 1.4em; color: #2f6db5; font-weight: bold; text-rendering: optimizelegibility; line-height: normal; padding: 16px 0 16px 0; } pre { background: #f8f4ee;font-family: Courier New,Courier,monospace;padding: 10px 20px !important; margin: 10px 0; box-shadow: 0 0 3px rgba(0, 0, 0, 0.07) inset; overflow-wrap: break-word; white-space: normal; } .api p { padding-bottom: 5px; } .pp{ background: #38a169; color: #fff; border-radius: 50%; font-size: 12px; padding: 2px; margin-right: 5px; } .NoteP ul{ margin-left: 10px;} .NoteP ul li{ margin-left: 10px; margin-bottom: 2px; } pre.NoteP { font-size: 12px; padding: 11px; display: block; margin-top: 4px; } p.Note { font-size: 12px; background-color: #F6F6F6; padding: 11px; display: block; margin-top: 4px; } hr { border: none; border-bottom: 1px solid gray; padding-bottom: 0px; padding-top: 0px; margin-top: 0px; margin-bottom: 0px; } dl { font-family: Helvetica, Arial, sans-serif; font-size: 12px } dl dt { font-family: Helvetica, Arial, sans-serif; font-size: 12px; font-weight: bold; padding-bottom: 3px; } dl dd { font-family: Helvetica, Arial, sans-serif; font-size: 12px; padding-bottom: 12px; padding-left: 18px; } .index { border-bottom: 1px solid #2f6db5; padding-bottom: 3px; margin-bottom: 10px; } .index_nav { padding-bottom: 3px; padding-left: 0; margin-bottom: 10px; margin-left: 0; } .index_nav li { display: inline; border-left: 1px solid #2f6db5; margin-left: 1px; padding-top: 5px; margin-right: 5px; font-weight: bold; } .index_nav li:first-child { border: none; } pre { background: #F8F4EE; font-family: "Courier New", Courier, monospace; font-size: 11px; padding-top: 0px; padding-right: 2px; padding-bottom: 10px; padding-left: 2px; overflow-x:auto; line-height: 15px; } .apidocContent p { display: block; font-family: Helvetica, Arial, sans-serif; font-size: 12px; color: #000; padding-bottom: 6px; padding-top: 0; } span.apidoc_code { font-family: "Courier New", Courier, monospace; font-size: 12px; } p.apidoc_note { font-family: Arial; font-size: 12px; background-color: #F6F6F6; padding: 11px; display:block; } .apidoc_note { font-family: Arial; font-size: 12px; background-color: #F6F6F6; padding: 11px; display:block; } p.Note { font-size: 12px; background-color: #F6F6F6; padding: 11px; display:block; } p.apidoc_image_p { font-family: Helvetica, Arial, sans-serif; font-size: 12px; line-height: 16px; color: #000000; overflow-x:auto; } .apidoc_image_p { font-family: Helvetica, Arial, sans-serif; font-size: 12px; line-height: 16px; color: #000000; overflow-x:auto; display:block; } .apidoc_overflow { overflow-x:auto; } .apidoc_p_subsequent { font-family: Helvetica, Arial, sans-serif; font-size: 12px; line-height: 16px; color: #000000; padding-bottom: 3px; } p.apidoc_backtotop { border-bottom: 1px solid gray; padding-top: 12px; padding-bottom: 8px; font-family: Helvetica, Arial, sans-serif; font-size: 12px; line-height: 12px; color: #000000; } span.apidoc_requestelementname { /*bold for request element name per wireframe design*/ color: #000000; font-weight: bold; } .stamp { border: 1px solid #B0B0B0; color: #909090; font-size: 75%; padding: 3px; display: inline-block; font-weight: normal; margin-bottom: 5px; }</style>');
          mywindow.document.write('</head><body style="margin:2mm">');
          mywindow.document.write(printContents);
          mywindow.document.write('</body></html>');
          mywindow.document.close(); // necessary for IE >= 10
          mywindow.focus(); // necessary for IE >= 10*/
          setTimeout(function () {
              mywindow.print();
              mywindow.close();
          }, 500);
          return false;
    },
    async getUser() {
      const res = await this.$me;
      this.currentUser = res.content;
    },
    async setSelected(seller) {
      if (seller) {
        console.log('seller',seller)
        this.formData.seller=seller;
        const res=await this.$server.generateToken("users", seller);
         this.formData.token=res.content;
      }
    },
     async getSellers() {
      const res = await this.$server.search("users", { type: "Seller",countries:await this.warhouseSelected,limit:10 });
      if (res.content.results) {
        this.sellers = res.content.results;
      }
    },
    /*******************************************Modal (View) update Chapping address and Status Order ************************************/
    ShowPopUpInformation(index,product) {
      this.selectProduct=product;
      let modal_id = "modal_" + index;
      this.$vm2.open(modal_id);
    },
  },
};
</script>

<style scoped>
textarea {
  position: absolute;
  left: -100%;
}
.section-1{
  width: 100%;
  padding-left: 40px;
  position: relative;
}
.section-1 .btn{
  vertical-align: middle;
  display: inline-flex;
  max-width: 100%;
  padding-bottom: 8px;
  border-radius: 6px;
  min-width: 0;
  flex-basis: auto;
  margin-top: 0;
  border-style: none;
  margin-bottom: 0;
  box-sizing: border-box;
  border-width: 0;
  align-items: center;
  flex-shrink: 0;
  cursor: pointer;
  padding-top: 8px;
  padding-left: 16px;
  padding-right: 16px;
  background-color: #64d441;
  color: white;
}
.section-1 .btn:focus,.section-1 .btn:visited{background-color: #299409;}

.section-1 .number{
  height: 24px;
  border-bottom-left-radius: 50%;
  width: 24px;
  border-top-right-radius: 50%;
  justify-content: center;
  display: flex;
  align-items: center;
  border-bottom-right-radius: 50%;
  left: 0;
  border-top-left-radius: 50%;
  top: 0;
  position: absolute;
  border: 2px solid #009;
}
.section-1 .title{
  min-width: 0;
  margin-bottom: 8px;
  font-weight: bold;
  color: rgba(0,0,0,.85);
  font-size: 1rem!important;
  word-wrap: normal;
  line-height: 1.25!important;
}
.section-1  .sous-title{
  margin-bottom: 12px;
  min-width: 0;
  color: rgba(0,0,0,.85);
  white-space: inherit;
  word-wrap: normal;
  line-height: 1.42858!important;
}
.number{
  color: #009;
  font-weight: normal;
}
.section-code{
  margin-bottom: 20px;
  border-top-right-radius: 8px;
  border-bottom-left-radius: 8px;
  overflow-x: hidden;
  border-bottom-right-radius: 8px;
  position: relative;
  border-top-left-radius: 8px;
  overflow-y: hidden;
  height: 135px;
  border-left: 1px solid #bec3c9;
  border-right: 1px solid #bdc2c8;
  border-bottom: 1px solid #c0c4ca;
  border-top: 1px solid #c2c7cd;
  width: 50%;
}
.section-code pre{
  padding-top: 16px;
  margin-top: 0;
  padding-right: 20px;
  margin-bottom: 0;
  overflow-x: hidden;
  padding-left: 20px;
  margin-left: 0;
  padding-bottom: 16px;
  margin-right: 0;
  overflow-y: hidden;
  white-space: pre-line;
}
.section-bottom{
  width: 100%;
  bottom: 0;
  position: absolute;
  top: 16px;
  background-image: linear-gradient(rgba(255,255,255,.4),rgba(255,255,255,1.0));
}
pre {
    display: block;
    font-family: monospace;
    white-space-collapse: preserve;
    text-wrap: nowrap;
}
h3{
  color: rgba(0,0,0,.85);
  white-space: inherit;
  font-size: 1.125rem!important;
  font-weight: bold;
}
.separe{
  padding-left: 1px;
  padding-right: 1px;
}
.imp{
  border: 2px solid rgb(245, 133, 4);
}
.Note table {
  font-family: sans-serif;
  display: block;
  width: 100%;
  overflow: scroll;
}
.Note table th,.Note table td {
  padding: 0.25em 0.5em;
  text-align: left;
}
.Note table th:nth-child(2), .Note table td:nth-child(2) {
  text-align: left;
}
.Note table td {
  background-color: #eee;
}
.Note table th {
  background-color: #009;
  color: #fff;
  font-size: 15px;
}
.tab-section{
  padding: 8px;
  border: 2px dashed black;
}

.zigzag {
  border-collapse: separate;
  border-spacing: 0.2em 0.33em;
}

.drag-el:hover,
.drag-el.over {
  background-color: #c56bc5;
}
.drop-zone {
  background-color: #eee;
  margin-bottom: 10px;
  padding: 10px;
}

.drag-el {
  background-color: #fff;
  margin-bottom: 10px;
  padding: 5px;
}
.bx--inline-notification {
  max-width: 100% !important;
  border-left: 3px solid #0043ce;
  background: #edf5ff;
  line-height: 1.625rem;
  color: #161616;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
}
.bx--inline-notification {
  position: relative;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  width: 100%;
  min-width: 18rem;
  height: auto;
  min-height: 3rem;
}
.bx--inline-notification--low-contrast::before {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  border-width: 1px 1px 1px 0;
  border-style: solid;
  content: '';
  -webkit-filter: opacity(0.4);
  filter: opacity(0.4);
  pointer-events: none;
  border-color: #0043ce;
}
.bx--inline-notification__details {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-flex: 1;
  -ms-flex-positive: 1;
  flex-grow: 1;
  margin: 0 1rem;
  line-height: 1.625rem;
  overflow-x: auto !important;
overflow-y: hidden !important;
}
.bx--inline-notification__icon {
  -ms-flex-negative: 0;
  flex-shrink: 0;
  margin-top: .875rem;
  margin-right: 1rem;
  fill: #0043ce;
}
.bx--inline-notification__text-wrapper {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  padding: .9375rem 0;
  line-height: 1.625rem;
}
.bx--inline-notification__subtitle {
  font-size: 1rem;
font-weight: 400;
line-height: 1.5;
letter-spacing: 0;
  word-break: break-word;
}
.bx--inline-notification__title {
  display: inline !important;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  letter-spacing: 0;
  font-weight: bold;
  margin: 0 .25rem 0 0;
  padding-bottom: 1rem;
  padding-top: 1rem;
}

.bx--list--ordered--temporary {
  font-size: 1rem !important;
  font-weight: 400 !important;
  letter-spacing: 0 !important;
  list-style-type: decimal !important;
  line-height: 1.5rem !important;
  margin-left: 1.75rem !important;
  margin-bottom: 1.5rem !important;
  list-style: none;
}
.bx--list--ordered--temporary > .bx--list__item {
  padding-left: .25rem !important;
}
.bx--list__item {
  color: #161616;
  margin-top: .25rem;
}
.uicontrol{
  font-weight: bold;
}
.NoteP .comment{
  color: #13a171;
}
.objet-pr{padding-left: 10px;display: block;}
.marker{
  list-style: disc outside none;
}
.circle-range {
    width: 8px;
    height: 8px;
    background:  black;
    border: 5px solid;
    border-radius: 50%;
    margin-right: 9px;
    display: inline-block;
    vertical-align: middle;
}
.objet{
  display: block;
  padding-left: 30px;
}
.api h2 {
    font-size: 1.4em;
    color: #3182cf;
    font-weight: bold;
    text-rendering: optimizelegibility;
    line-height: normal;
    padding: 16px 0 16px 0;
}
pre {
    padding: 10px 20px !important;
    margin: 10px 0;
    box-shadow: 0 0 3px rgba(0, 0, 0, 0.07) inset;
    overflow-wrap: break-word;
    white-space: normal;
}
.api p {
    padding-bottom: 5px;
}
.pp{
  background: #38a169;
  color: #fff;
  border-radius: 50%;
  font-size: 12px;
  padding: 2px;
    margin-right: 5px;
}
.NoteP ul{
  margin-left: 10px;
}
.NoteP ul li{
  margin-left: 10px;
}
pre.NoteP {
    font-size: 12px;
    padding: 11px;
    display: block;
    margin-top: 4px;
}
p.Note {
    font-size: 12px;
    background-color: #F6F6F6;
    padding: 11px;
    display: block;
    margin-top: 4px;
}

hr { 
	border: none;
	border-bottom: 1px solid gray;
	padding-bottom: 0px;
	padding-top: 0px;
	margin-top: 0px;
	margin-bottom: 0px;
}


dl { 
	font-family: Helvetica, Arial, sans-serif;
	font-size: 12px
}

dl dt {
	font-family: Helvetica, Arial, sans-serif;
	font-size: 12px;
	font-weight: bold;
	padding-bottom: 3px;
}

dl dd { 
	font-family: Helvetica, Arial, sans-serif;
	font-size: 12px;
	padding-bottom: 12px;
	padding-left: 18px;
}

.index { 
	border-bottom: 1px solid #2f6db5;
	padding-bottom: 3px;
	margin-bottom: 10px;
}

.index_nav { 
	padding-bottom: 3px;
	padding-left: 0;
	margin-bottom: 10px;
	margin-left: 0;
}

.index_nav li { 
	display: inline;
	border-left: 1px solid #2f6db5;
	margin-left: 1px;
	padding-top: 5px;
	margin-right: 5px;
	font-weight: bold;
}

.index_nav li:first-child { 
	border: none;
}

pre { 
	background: #F8F4EE;
	font-family: "Courier New", Courier, monospace;
	font-size: 11px;
	padding-top: 0px;
	padding-right: 2px;
	padding-bottom: 10px;
	padding-left: 2px;
	overflow-x:auto;
	line-height: 15px;
}


.apidocContent p {
	display: block;
	font-family: Helvetica, Arial, sans-serif;
	font-size: 12px;
	color: #000;
	padding-bottom: 6px;
	padding-top: 0;
}

span.apidoc_code { 
	font-family: "Courier New", Courier, monospace;
	font-size: 12px;
}

p.apidoc_note { 
	font-family: Arial;
	font-size: 12px;
	background-color: #F6F6F6;
	padding: 11px;
	display:block;
}

.apidoc_note { 
	font-family: Arial;
	font-size: 12px;
	background-color: #F6F6F6;
	padding: 11px;
	display:block;
}


p.Note {
	font-size: 12px;
	background-color: #F6F6F6;
	padding: 11px;
	display:block;
}

p.apidoc_image_p { 
	font-family: Helvetica, Arial, sans-serif;
	font-size: 12px;
	line-height: 16px;
	color: #000000;
	overflow-x:auto;
}

.apidoc_image_p { 
	font-family: Helvetica, Arial, sans-serif;
	font-size: 12px;
	line-height: 16px;
	color: #000000;
	overflow-x:auto;
	display:block;
}

.apidoc_overflow { 
	overflow-x:auto;
}

.apidoc_p_subsequent {
	font-family: Helvetica, Arial, sans-serif;
	font-size: 12px;
	line-height: 16px;
	color: #000000;
	padding-bottom: 3px;
}

p.apidoc_backtotop {
	border-bottom: 1px solid gray; 
	padding-top: 12px;
	padding-bottom: 8px;
	font-family: Helvetica, Arial, sans-serif;
	font-size: 12px;
	line-height: 12px;
	color: #000000;
}

span.apidoc_requestelementname { /*bold for request element name per wireframe design*/
	color: #000000;
	font-weight: bold;
}

.stamp {
            border: 1px solid #B0B0B0;
            color: #909090;
            font-size: 75%;
            padding: 3px;
            display: inline-block;
            font-weight: normal;
            margin-bottom: 5px;
}
</style>
